//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    current: {
      type: Number,
      default: 1,
    },
    count: {
      type: Number,
      default: 3,
    },
  },
};
